import TeceoLogo from '@components/v2/ui/TeceoLogo/TeceoLogo';
import Typography from '@components/v2/ui/Typography/Typography';
import { ReactNode } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import useAuthPanelStyles from './authPanel.styles';

interface AuthPanelProps {
  description?: LangEnum;
  children: ReactNode;
  below?: ReactNode;
}

const AuthPanel = ({ description, children, below }: AuthPanelProps) => {
  const { classes } = useAuthPanelStyles();
  const { translate } = useTranslation();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <TeceoLogo width={135} height={24} />
        {description && (
          <Typography
            variant="body2"
            color="text.secondary"
            align="left"
            sx={{ alignSelf: 'stretch' }}
          >
            {translate(description)}
          </Typography>
        )}
        {children}
      </div>
      {below}
    </div>
  );
};

export default AuthPanel;
